import React, { useId, useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { ChevronDown } from "lucide-react";
import { getOrderWagonNumbers } from "../../../../pages/orders/utils/railwayOrder";
import WagonsCountIcon from "../../../shared/icons/WagonsCountIcon";
import common from "../common.module.scss";
import style from "./CargoWagonNumbers.module.scss";

const CargoWagonNumbers = ({ order }) => {
  const { t } = useTranslation();
  const numbers = getOrderWagonNumbers(order);
  const count = order?.isComplexTender === true ? order.vehiclesCount : order?.wagonsCount;
  const [isOpen, setIsOpen] = useState(false);
  const listId = useId();

  if (count == null) return null;

  return (
    <div className={style.wrapper}>
      <div className={cn(common.cargo_details, common.cargo_railwayDetail)}>
        <WagonsCountIcon />
        <div className={common.cargo_category}>{t("railwayOrder.wagonsCount")}:</div>
        <span className={common.cargo_railwayValue}>{count}</span>
        {numbers.length > 0 && (
          <button
            type="button"
            className={style.toggle}
            aria-label={t("railwayOrder.wagonNumbers")}
            aria-expanded={isOpen}
            aria-controls={listId}
            onClick={() => setIsOpen((previous) => !previous)}
          >
            <ChevronDown size={18} className={style.chevron} aria-hidden="true" />
          </button>
        )}
      </div>
      {isOpen && numbers.length > 0 && (
        <div className={style.panel}>
          <ol
            id={listId}
            className={style.list}
            aria-label={t("railwayOrder.wagonNumbers")}
            tabIndex={numbers.length > 4 ? 0 : undefined}
          >
            {numbers.map((number, index) => (
              <li key={index} className={style.row}>
                <span className={style.rowLabel}>
                  {t("railwayOrder.wagonNumber")} {index + 1}:
                </span>
                <b className={style.number}>{number}</b>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
};

export default CargoWagonNumbers;
